<template>
  <div class="y-form-ctr setup-ctr">
    <setup-env :data="setupCompData" />
    <el-divider class="setup-divider"></el-divider>
    <setup-login />
    <el-divider class="setup-divider"></el-divider>
    <setup-products />
    <el-divider class="setup-divider"></el-divider>
    <setup-contact />
    <el-divider class="setup-divider"></el-divider>
    <div class="y-form-group">
      <el-row class="y-form-group-header">
        <el-col class="y-form-group-header__icon icon-setup-publish" :span="4">&nbsp;</el-col>
        <el-col class="y-form-group-header__text" :span="20">{{ $lang.messages.not_yet_published }}</el-col>
      </el-row>
      <div class="y-form-item-group">
        <div class="y-form-row y-form-row__fullwidth">
          <el-button type="primary" class="y-button">Publish setup privately</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SetupEnv from './setup_env.vue'
import SetupLogin from './setup_login.vue'
import SetupProducts from './setup_products.vue'
import SetupContact from './setup_contact.vue'
import validatePublicKey from '../../mixins/validator'
export default {
  name: 'SubbrandSetupForm',
  components: {
    'setup-env': SetupEnv,
    'setup-login': SetupLogin,
    'setup-products': SetupProducts,
    'setup-contact': SetupContact
  },
  $_veeValidate: {
    validator: 'new'
  },
  provide() {
    return {
      $validator: this.$validator
    }
  },
  data() {
    return {
      envSetupForm: {
        customerName: '',
        url: '',
        ipAddress: []
      }
    }
  },
  created() {
    this.$validator.extend('alpha_num_dash_spaces', {
      getMessage: field =>
        'Please use only letters, numbers, dashes, and white-spaces.',
      validate: value => {
        var validData = true
        // var regex = new RegExp('^[a-zA-Z0-9]+((\\s|-)[a-zA-Z0-9-]+)*$')
        var regex = new RegExp(
          '^[a-zA-Z]{1}[a-zA-Z0-9-]*((\\s-|-\\s|-|\\s)[a-zA-Z0-9-]+)*((\\s-|-\\s|-|\\s|)[a-zA-Z0-9]+)+$'
        )
        if (!regex.test(value.trim())) {
          validData = false
        }
        return validData
      }
    })
    this.$validator.extend('alpha_num_dash', {
      getMessage: field => 'Please use only letters, numbers and dashes.',
      validate: value => {
        var validData = true
        // var regex = new RegExp('^[a-zA-Z0-9]+[a-zA-Z0-9-]*$')
        var regex = new RegExp('^[a-zA-Z][a-zA-Z0-9]+[a-zA-Z0-9-]*[a-zA-Z0-9]$')
        if (!regex.test(value.trim())) {
          validData = false
        }
        return validData
      }
    })
    this.$validator.extend('isValidRsaKey', {
      getMessage: field => 'RSA Public key is not valid.',
      validate: value => {
        return validatePublicKey.validatePublicKey(value)
      }
    })
  },
  computed: {
    selectedSubbrandData() {
      return this.$store.state.appStore.selectedSubbrandInfo
    },
    isEditFlow() {
      var isEditFlow = false
      if (this.selectedSubbrandData && this.selectedSubbrandData.status) {
        if (this.selectedSubbrandData.status !== 7) {
          isEditFlow = true
        }
      }
      return isEditFlow
    },
    setupCompData() {
      let setupCompData = {
        isEditFlow: this.isEditFlow
      }
      return setupCompData
    }
  },
  methods: {}
}
</script>

<style>
.setup-ctr {
  width: 100%;
  display: block;
  margin: 70px;
}
</style>
